export const clientNames = {};

export const clientIds = {};

// This array contains all ids that have the new custom menu setup, add ids here to extend this list to new clients
export const customMenuIds = [];
export const customFooterIds = [];
export const customJobListingNav = [];
export const customPreHeader = [];
export const optionThreeClients = [];
export const option2Clients = [];
export const option4Clients = [];


/**
 * uses this setting for custom menu's UI elements and assets
 * @description menuType : 1 - normal menu, 2 - mega menu
 */
export const customMenuUISettings = [];

//Controls responsive UI elements, ex: accordion component
export const responsiveSettings = {
  template5MenuBreakpoint: 768,
  template6FooterBreakpoint: 899,
  vyMenuBreakpoint: 960,
};

export const customFooterUISettings = [];

/**
 * customLinkData
 * @description custom menu links and control data
 * @param id - id to be used as a reference
 * @param href - link for the main menu item
 * @param name - text for the menu item
 * @param active - maintains hovered over state UI
 * @param open - state for setting sub menu open/close
 * @param custommenuTemplate - in case we need to inject a full html template into a submenu, eg., mega menus
 * @param subType subType - string, for added changes to different sub menu types
 * @param submenu/icon - for adding icons classes for icon type sub menus
 */
export const customLinkData = [];


export const clients = [];
